import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import InputTextArea from "./InputTextArea";
import { Divider } from "primereact/divider";
import LocalDelimitationNational from "./LocalDelimitationNational";
import { changeLang } from "./Language/ChangeLang";
import { DermacationLevels } from "../constants";

const AddDermacation = ({
	onSave = () => { },
	editMode = false,
	setDialogVisible,
	showDialog = false,
	setdermacationForm,
	dermacationForm,
	setNodeName,
	nodeName,
	selectedEvent,
	isNational
}) => {

	useEffect(() => {
		setdermacationForm((prev) => ({
			...prev,
			name: "",
			no: "",
			code: "",
			description: ""
		}));
		setLocalDelimitation(raw)
	}, [showDialog, editMode]);

	var raw = {
		districts: [],
		districtID: null,
		districtName: null,
		councils: [],
		councilID: null,
		councilName: null,
		votingDistricts: [],
		votingDistrictID: null,
		votingDistrictName: null,
		votingStations: [],
		votingStationID: null,
		votingStationName: null,
		villages: [],
		villageID: null,
		villageName: null,
		level: null,
		delimitationID: null
	};
	const [villageDialogVisible, setVillageDialogVisible] = useState(false);
	const [localDelimitation, setLocalDelimitation] = useState(raw);
	if (!dermacationForm) return null;

	const extractVotingDistrictPrefix = () => dermacationForm?.votingDistrictName?.match(/\d+/)?.[0] ?? "";

	const extractRegistrationCentrePrefix = () => dermacationForm?.votingDistrictName?.match(/\d+/)?.[0] ?? "";
	const canEditRC = dermacationForm.level === DermacationLevels?.Level4 && dermacationForm.districtID && dermacationForm.constituencyID && dermacationForm.votingDistrictID;

	const canEditVillage =
		editMode ||
		(dermacationForm.level === DermacationLevels?.Level5 &&
			dermacationForm.registrationCentreID &&
			dermacationForm.districtID &&
			dermacationForm.constituencyID &&
			dermacationForm.votingDistrictID);
	const removeDigitCode = (value = "") => {
		return value.replace(/^\s*\d+\s*-\s*/, "");
	};


	return (
		<>
			<Dialog
				header={editMode ? "Update Demarcation" : "Add Demarcation"}
				visible={showDialog}
				style={{ width: "80vw", height: "95vh" }}
				onHide={() => setDialogVisible(false)}
				footer={
					<div className="flex justify-content-end gap-2">
						<Button label="Cancel" icon="pi pi-times" text onClick={() => setDialogVisible(false)} />
						<Button
							label={editMode ? "Update" : "Add"}
							icon="pi pi-check"
							onClick={() => onSave(dermacationForm)}
							disabled={(dermacationForm.level === DermacationLevels?.Level4 && !canEditRC) || (dermacationForm.level === DermacationLevels?.Level5 && !canEditVillage)}
						/>
					</div>
				}
				className="py-4"
			>
				<div className="p-fluid py-4 card mt-4">
					<Divider>
						<h3>Demarcation Details</h3>
					</Divider>
					
					<div className="grid mb-3">
						{/* District */}
						<div className="col-12 lg:col-6">
							<label>
								{isNational ? changeLang.get("national_delimitation.district") : changeLang.get("local_delimitation.district")}
							</label>
							<InputText value={dermacationForm.districtName || ""} disabled />
						</div>

						{/* Constituency */}
						<div className="col-12 lg:col-6">
							<label>
								{isNational ? changeLang.get("national_delimitation.constituency") : changeLang.get("local_delimitation.council")}
							</label>
							<InputText value={dermacationForm.constituencyName || ""} disabled />
						</div>

						{/* Voting District */}
						<div className="col-12 lg:col-6">
							<label>
								{isNational
									? changeLang.get("national_delimitation.electoralDivision")
									: changeLang.get("local_delimitation.electoralDivision")}
							</label>
							<InputText value={dermacationForm.votingDistrictName || ""} disabled />
						</div>

						{/* Registration Centre */}
						{dermacationForm.level === 4 && (
							<>
								<div className="col-12 lg:col-6">
									<label>Registration Centre Name</label>
									<InputText
										value={removeDigitCode(dermacationForm.name) || ""}
										placeholder="Enter Registration Centre Name"
										disabled={!canEditRC}
										onChange={(e) => {
											const value = e.target.value.toUpperCase();
											setNodeName(value);
											setdermacationForm((prev) => ({
												...prev,
												name: value
											}));
										}}
									/>
								</div>

								<div className="col-12 lg:col-6">
									<label>
										Registration Centre Number <span className="text-error">*</span>
									</label>
									<InputText
										value={isNational ? dermacationForm.no : dermacationForm.no}
										placeholder="Enter RC Number"
										disabled={!canEditRC}
										onChange={(e) => {
											let num = e.target.value.trim();

											num = num.replace(/^0+/, "");

											// Add leading zero if single digit (1-9)
											if (/^[1-9]$/.test(num)) {
												num = `0${num}`;
											}

											const finalCode = `${extractVotingDistrictPrefix()}${num}`;
											isNational
												? setdermacationForm((prev) => ({
													...prev,
													no: Number(num),
													code: finalCode
												}))
												: setdermacationForm((prev) => ({
													...prev,
													no: Number(num),
													code: finalCode
												}));
										}}
									/>
								</div>
								{/* Code */}
								<div className="col-12 lg:col-6">
									<label>Code</label>
									<InputText value={dermacationForm.code || ""} disabled />
								</div>
							</>
						)}

						{/* Village */}
						{dermacationForm.level === DermacationLevels?.Level5 && (
							<>
								<div className="col-12 lg:col-6">
									<label>
										Registration Centre Name <span className="text-error">*</span>
									</label>
									<InputText value={dermacationForm?.registrationCentreName || ""} placeholder="Enter RC Name" disabled />
								</div>
								<div className="col-12 lg:col-6">
									<label>
										Village Number <span className="text-error">*</span>
									</label>
									<InputText
										value={dermacationForm.no || ""}
										placeholder="Enter Village Number"
										onChange={(e) => {
											let num = e.target.value.trim();
											num = num.replace(/^0+/, "");
											if (/^[1-9]$/.test(num)) {
												num = `0${num}`;
											}
											const finalCode = `${extractRegistrationCentrePrefix()}${num}`;
											setdermacationForm((prev) => ({
												...prev,
												no: Number(num),
												code: finalCode
											}));
										}}
									/>
								</div>
								<div className="col-12 lg:col-6 flex">

									<div className="lg:col-6">

										<label>
											Select Registration Centre <span className="text-error">*</span>
										</label>
										<Button
											value={dermacationForm.name || ""}
											placeholder="Enter Village Name"
											onClick={() => {
												setVillageDialogVisible(true)
											}}
											label={editMode ? " Update Registration Centre" : " Add Registration Centre"}
											className="pi pi-plus p-button-success px-2"
										/>
									</div>
									<div className="lg:col-6">

										<label>
											Village Name <span className="text-error">*</span>
										</label>
										<InputText
											value={removeDigitCode(dermacationForm.name) || ""}
											placeholder="Enter Village Name"
											onChange={(e) => {
												const value = e.target.value.toUpperCase();
												setNodeName(value);
												// setNodeName(value);
												setdermacationForm((prev) => ({
													...prev,
													name: value
												}));
											}}

										/>
									</div>

								</div>
								<div className="col-12 ">
									<label>Code</label>
									<InputText value={dermacationForm.code || ""} disabled />
								</div>
							</>
						)}
						<div className="col-12">
							<label>Description</label>
							<InputTextArea
								value={dermacationForm.description || ""}
								placeholder=""
								onChange={(e) =>
									setdermacationForm((prev) => ({
										...prev,
										description: e.target.value.toUpperCase()
									}))
								}
							/>
						</div>
					</div>
					{
						localDelimitation?.votingStationName &&
						<div className="card">
							<div className="grid mb-3">
								<div className="col-12 lg:col-6">
									<label>{isNational ? changeLang.get("national_delimitation.district") : changeLang.get("local_delimitation.district")}</label>
									<div className=" p-inputtext p-component p-filled p-disabled">{localDelimitation?.districtName}</div>
								</div>
								<div className="col-12 lg:col-6">
									<label>
										{" "}
										{isNational ? changeLang.get("local_delimitation.council") : changeLang.get("national_delimitation.constituency")}
									</label>
									<div className=" p-inputtext p-component p-filled p-disabled">{localDelimitation?.councilName}</div>
								</div>
								<div className="col-12 lg:col-6">
									<label>
										{isNational
											? changeLang.get("local_delimitation.electoralDivision")
											: changeLang.get("national_delimitation.electoralDivision")}
									</label>
									<div className=" p-inputtext p-component p-filled p-disabled">{localDelimitation?.votingDistrictName}</div>
								</div>
								{dermacationForm?.level > DermacationLevels?.Level4 && (
									<div className="col-12 lg:col-6">
										<label>{changeLang.get("national_delimitation.votingCentre")}</label>
										<div className=" p-inputtext p-component p-filled  p-disabled">{localDelimitation?.votingStationName}</div>
									</div>
								)}
							</div>
						</div>
					}

				</div>
			</Dialog>
			<Dialog
				header="Select Village"
				visible={villageDialogVisible}
				style={{ width: "70vw", height: "80vh" }}
				onHide={() => setVillageDialogVisible(false)}
			>
				<LocalDelimitationNational
					showVillage={false}
					setLocalDelimitation={setLocalDelimitation}
					isNational={!isNational}
					onChange={(delimitationID, level, data) => {
						if (!data) return;
						if (isNational) {
							setdermacationForm((prev) => ({
								...prev,
								registrationCenterLGID: data,
								delimitationLevelID: level
							}));
						} else {
							setdermacationForm((prev) => ({
								...prev,
								registrationCenterNAID: data,
								delimitationLevelID: level
							}));
						}
						if (level === 4 && data) {
							setVillageDialogVisible(false);
						}
					}}
				/>
			</Dialog>
		</>
	);
};

export default AddDermacation;
